import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/interfaces";
import { EStatisticsTab, EStatisticsTimespan } from "./enums";
import { BehaviorSubject, Observable } from "rxjs";
import { IStatisticsCategoryArgs } from "./interfaces";

@Injectable({
    providedIn: "root"
})
export class ChangeStatisticsTabUseCase implements IUseCase<EStatisticsTab, void> {
    private _currentStatisticsTab: BehaviorSubject<IStatisticsCategoryArgs> = new BehaviorSubject<IStatisticsCategoryArgs>({ category: EStatisticsTab.AllBets });

    execute(data: EStatisticsTab, modifier?: EStatisticsTimespan): void {
        this._currentStatisticsTab.next({ category: data, modifier });
    }

    subscribeStatisticsTab(): Observable<IStatisticsCategoryArgs> {
        return this._currentStatisticsTab.asObservable();
    }
}
